import React, { useState } from 'react';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import MDTypography from 'components/MDTypography';
import { getDataGridHeading } from 'utils/commonUtils';
import MyPreferencesDialog from '../myPreferences/MyPreferencesDialog';
import { HeadingMuiTypography, GridWrapper } from 'components/Ui/styled';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const MyProfileInfo = (props) => {
  const { profilePreferences, setProfilePreferences } = props;

  const [myPreferencesDialog, setMyPreferencesDialog] = useState(false);

  const canAccessUserPreferences = usePermissionCustomHook(
    'CAN_ACCESS_USER_PREFERENCES',
  );

  const myProfile = useSelector((state) => state?.myProfile);

  const {
    user,
    supervisedUsers,
    tokenGroups,
    isSuperuser,
    metadata,
    assignedAssets,
  } = myProfile || {};

  const {
    readWriteSupervisorOfGroups,
    readOnlySupervisorOfGroups,
    activeCompanyAssociations = {},
    assignedLocations,
  } = user || {};

  const { supervisedReadWrite, supervisedReadOnly, allSupervisedUsers } =
    supervisedUsers || {};

  const { watchingSchools, watchingStudents } = metadata || {};

  const profileFields = [
    {
      label: 'Name',
      value: `${user?.givenName || ''} ${user?.familyName || ''}`.trim() || '-',
    },
    { label: 'Username', value: user?.username },
    { label: 'Email', value: user?.email },
    { label: 'Job Title', value: user?.jobTitle },
    { label: 'Date of Birth', value: user?.dateOfBirth },
    { label: 'Home Address', value: user?.homeAddress },
  ];

  const emergencyFields = [
    {
      label: 'Emergency Contact Name',
      value:
        `${user?.emergencyContactGivenName || ''} ${
          user?.emergencyContactFamilyName || ''
        }`.trim() || '-',
    },
    { label: 'Phone', value: user?.emergencyContactPhoneNumber },
    { label: 'Address', value: user?.emergencyContactAddress },
    { label: 'Relation', value: user?.emergencyContactRelation },
    { label: 'Superuser', value: isSuperuser ? 'Yes' : 'No' },
    { label: 'Vonage Extension', value: user?.vonageExtension },
  ];

  const profilePreferencesInfo = [
    {
      label: 'Enabled Email Notifications',
      value: profilePreferences?.emailNotificationsEnabled ? 'Yes' : 'No',
    },
    {
      label: 'Enabled Tutor Email Notifications',
      value: profilePreferences?.tutorEmailNotificationsEnabled ? 'Yes' : 'No',
    },
  ];

  const activeCompanies = Object.entries(activeCompanyAssociations).filter(
    ([_, isActive]) => isActive,
  );

  const ChipGroupSection = ({
    title,
    items = [],
    getKey = (item) => item,
    getLabel = (item) => item,
    chipColor = 'default',
    variant = 'filled',
    noneText = 'None',
  }) => (
    <MDBox>
      <MDTypography
        variant="button"
        fontWeight="bold"
        textTransform="capitalize"
        mb={1}
      >
        {title}
      </MDTypography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {items?.length > 0 ? (
          items.map((item) => (
            <Chip
              key={getKey(item)}
              label={getLabel(item)}
              color={chipColor}
              variant={variant}
              size="medium"
              style={{ marginBottom: '8px' }}
            />
          ))
        ) : (
          <MDTypography variant="button" fontWeight="regular" color="text">
            &nbsp;{noneText}
          </MDTypography>
        )}
      </Stack>
    </MDBox>
  );

  const handleMyPreferences = async () => {
    setMyPreferencesDialog(true);
  };

  return (
    <>
      {/* <Card>*/}
      {/* {getDataGridHeading(
          'Profile Information',
          canAccessUserPreferences && 'My Preferences',
          canAccessUserPreferences ? handleMyPreferences : undefined
        )} */}
      <MDBox mb={1}></MDBox>
      <GridWrapper container spacing={2} style={{ padding: '0px 24px' }}>
        <Grid item xs={12} sm={4}>
          {profileFields?.map((field) => (
            <MDBox key={field.label}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {field.label}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{field.value || '-'}
              </MDTypography>
            </MDBox>
          ))}
        </Grid>
        <Grid item xs={12} sm={4}>
          {emergencyFields?.map((field) => (
            <MDBox key={field.label}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {field.label}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{field.value || '-'}
              </MDTypography>
            </MDBox>
          ))}
        </Grid>
        {/* <Grid item xs={12} sm={4}>
            {canAccessUserPreferences &&
              profilePreferencesInfo.map((field) => (
                <MDBox key={field.label}>
                  <MDTypography
                    variant="button"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    {field.label}: &nbsp;
                  </MDTypography>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    &nbsp;{field.value || '-'}
                  </MDTypography>
                </MDBox>
              ))}
          </Grid> */}
      </GridWrapper>
      <GridWrapper container spacing={2} style={{ padding: '0px 24px' }}>
        <Grid item xs={12}>
          <ChipGroupSection title="Groups:" items={tokenGroups} />
          <ChipGroupSection
            title="Supervisor Read/Write Group:"
            items={readWriteSupervisorOfGroups}
          />
          <ChipGroupSection
            title="Supervisor Read Only Groups:"
            items={readOnlySupervisorOfGroups}
          />
          <ChipGroupSection
            title="All Supervised Users:"
            items={allSupervisedUsers}
          />
          <ChipGroupSection
            title="Supervised Read/Write Users:"
            items={supervisedReadWrite}
          />
          <ChipGroupSection
            title="Supervised Read-Only Users:"
            items={supervisedReadOnly}
          />
          <ChipGroupSection
            title="Active Company Associations:"
            items={activeCompanies}
            getKey={([company]) => company}
            getLabel={([company]) => company.toUpperCase()}
            chipColor="success"
          />

          <ChipGroupSection
            title="Assigned Locations:"
            items={assignedLocations}
            getKey={(loc) => loc.id}
            getLabel={(loc) => loc.val}
            chipColor="primary"
            variant="outlined"
          />

          <ChipGroupSection
            title="Watching Schools:"
            items={watchingSchools}
            chipColor="info"
            variant="outlined"
          />

          <ChipGroupSection
            title="Watching Students:"
            items={watchingStudents}
            chipColor="secondary"
            variant="outlined"
          />
        </Grid>
      </GridWrapper>
      <HeadingMuiTypography variant="h6">My Assets:</HeadingMuiTypography>
      <GridWrapper container spacing={2} style={{ padding: '0px 24px' }}>
        {assignedAssets?.map((asset, index) => {
          const assetFields = [
            { label: 'Asset Tag', value: asset.assetTag },
            { label: 'Type', value: asset.type?.val },
            { label: 'Building', value: asset.building?.val },
            { label: 'Location', value: asset.location?.val },
            { label: 'Funding', value: asset.funding?.val },
            { label: 'Serial', value: asset.serial },
            { label: 'Manufacturer', value: asset.manu },
            { label: 'Model', value: asset.model },
            { label: 'Acquired On', value: asset.acquired },
            { label: 'Verified On', value: asset.verified },
            { label: 'Retired On', value: asset.retired || 'Not retired' },
            { label: 'Assigned Note', value: asset.assignedNote },
          ];

          return (
            <Grid key={asset.id || index} item xs={12} sm={3}>
              <MDBox key={asset.id} mb={3}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                  mb={1}
                >
                  Asset {index + 1}
                </MDTypography>
                {assetFields.map((field) => (
                  <MDBox key={field.label}>
                    <MDTypography
                      variant="button"
                      fontWeight="bold"
                      textTransform="capitalize"
                    >
                      {field.label}: &nbsp;
                    </MDTypography>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      &nbsp;{field.value || '-'}
                    </MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </Grid>
          );
        })}
      </GridWrapper>
      {/* </Card> */}
      <MyPreferencesDialog
        myPreferencesDialog={myPreferencesDialog}
        setMyPreferencesDialog={setMyPreferencesDialog}
        profilePreferences={profilePreferences}
        setProfilePreferences={setProfilePreferences}
      />
    </>
  );
};

export default MyProfileInfo;
